<form #registerForm="ngForm">
  <input type="text" name="username" required [(ngModel)]="model.username">
  <input type="password" name="password" required [(ngModel)]="model.password">
  <button type="submit">Register</button>
  <button type="button">Cancel</button>
</form>